<template>
  <div class="wps-template vh100">
    <router-view></router-view>
  </div>
</template>

<script>
  import keys from 'lodash.keys'
  import login from '@/utils/login'
  // import module from '../../modules/WpsTemplate/index'
  // import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

  export default {
    computed: {
      // ...mapState(module.name, keys(module.state)),
      // ...mapGetters(module.name, keys(module.getters))
    },
    methods: {
      // ...mapMutations(module.name, keys(module.mutations)),
      // ...mapActions(module.name, keys(module.actions))
    },
    beforeCreate () {
      // this.$store.registerModule(module.name, module)
    },
    async created () {
      await login.login()
    },
    beforeDestroy () {
      // this.$store.unregisterModule(module.name)
    },
    components: {

    }
  }
</script>

<style lang="scss">
  @charset "UTF-8";
  @import "../../style/main";

  .wps-template {
    /*min-height: 100vh;*/
    overflow: scroll;
    /*height: 100vh;*/
    background-color: #f3f4f6;
  }
</style>
